import { SxProps, Theme } from '@mui/material';

export const rootSx: SxProps<Theme> = {
	justifyContent: 'center',
	alignItems: 'center',
	marginLeft: '10px',
	'.MuiTypography-root': {
		marginLeft: '5px',
		marginRight: '5px',
	},
};
